module.exports = __webpack_public_path__ + "dd2c2162c3f8ac5c89c8c7612d16eea2.svg";